import React from "react";

function Message(isVisible) {
  return (
    <>
      <span className={isVisible}>
        <pre id="message-text">{`

          Община Стара Загора
Фондация „Космос – Д.Брацов” - Стара Загора
НЧ „Николай Лилиев – 2005“ Стара Загора
НЧ „Даскал Петър Иванов – 1988“ Стара Загора
Дружество на писателите – Стара Загора
Регион. библиотека „Захарий Княжески“ Ст.Загора

Тринадесето издание – 2026 година
Национален и с международно участие поетичен конкурс
„Николай Лилиев‘ 2026 г. – Стара Загора

НАГРАДЕНИ СТИХОТВОРЕНИЯ

1 МЯСТО

Стелияна  Маринова -Естела Маре – гр. Велико Търново

***
Приседналата есен на коляно, 
във мислите ми стихове бродира 
от  Лилиев  и  Димчо  Дебелянов 
да нямат недоспивките ми мира

от моите прихлопванки сърдечни, 
от кървавите белези в очите! 
Нали си пожелах любов и вечност, 
а само между тях на сляпо скитах!

В зениците ми залезът мълнее, 
разчупен на светкавици кипящи! 
Препъвам се в задрямали злодеи
и с болка си откупвам настояще!

Да можех с добрина и с кротка нежност 
мечтите си безцветни да изпъстря! 
Животът е Голгота неизбежна  
с белязан хълм, към който нося кръста!

И в нощи от тревоги непрогледни, 
с луна като мъждукащо кандило, 
ще чакам самотата ми да седне, 
на чаша вино, мрака утаило!

Ще пием за урока си съдбовен, 
за счупените чувства и раздели, 
че всяка трудност Божия любов е, 
с която сме във мрака оцелели!




2 МЯСТО

Мария Панайотова, гр. Ямбол

ВЛЮБЕНАТА ТОЧИЦА
Страхувам се от тази тишина.
на твоя стол поискала да седне.
Защото знам, че точица една
си обещахме с тебе до последно. 

Когато я усетих, мина ток
през мене, а душата ми засвети.
И помня, че в съня ми влезе Бог,
да чуе на сърцето ми обета.

Аз вече бях разбрала стойността
на точката, която с теб ме свърза.
Подарък беше от случайността,
открила  двама в късната им дързост.

Печата воден на една сълза
поставихме в небесните тефтери.
Зарекох се за теб да съм бреза,
а ти – към връх висок да се катериш.

Животът, който бе за мен кафез,
ти с влюбената точица отключи.
Беззвучният ми глас, прошепнал: Влез! –
на толкова вълшебства те научи.

Аз чувствам, как прехвърчат между нас
искрите на взаимните флуиди.
Страхувам се от този ден и час,
когато празен стола ти ще видя.






3 МЯСТО

Маргарита Борисова Мартинова,  гр. София

ТРАЕКТОРИЯ НА УПОВАНИЕТО


На небесната сцена 
пригърмя изведнъж  
и завесата в Храма се скъса в  средата.  
В светлините изплува силуетът на мъж.  
Господ слезе и тръгна
пеша по Земята. 

Под краката му боси 
се размазва калта.  
Край казана с боклука лежат вехтошари.  
Лимузини раздуват с мръсна газ из града.  
Няма никой над Бог
да го гушне и жали.  

Боже, колко е просто:
два-три хляба купи,    
милостиня раздай по бедняшки квартали.  
Всеки сам да избира участта да греши. 
Напиши SOS върху 
свойте Скрижали!  

Превърни се в художник
неразбран. Без ухо.
Поживей като него. Дари му утеха.  
Постави го по-горе от платно с Пикасо.  
Изкърпи на гърба му
пробитата дреха.   

Отнеми, ако трябва, 
всички грешни пари.   
Дай ни само бои! И кажи как се прави: 
Да рисуваш, а всичко във теб да боли?
За да бъдеш Ван Гог.
Луд. Велик. Изоставен….






ПООЩРЕНИЯ

Петя Михайлова Стефанова-Глеридис, гр. Търговище


СПОМЕН ЗА ВСИЧКИ НЕГОВИ ТЪЖНИ ЖЕНИ

(на Маркес)

Неотпивани чаши за бира ще чакат в Макондо на бара – 
набързо обърнати рокли, лишени от женски тела. 
Унило целуващи устни ще ги докосват с вяла немара, 
протяжни вълни ще прегръщат със плясък две мокри крила. 

Закъснели стъпки по пясъка парещ няма кой да остави. 
Тук септември – дългунест хлапак – пощипва сочното лято. 
Ще изтляват и с пепелта ще разказват ланшните юлски жарави, 
,,Полковникът няма кой да му пише“ в нечий ум се премята. 

До съня ми с тази лодка нежно в най-лошия си час ще стигнеш, 
за да имат любовта и другите демони хроника. 
Когато стогодишна самота с пестници ледни те притисне – 
две сълзи ли над окапалата шума се отрониха? 

Неотпивани чаши в Макондо ще чакат под слънчева арка – 
живее, за да разказва последната си есен патриархът. 






Стефания Цанкова, Велико Търново

ПРОЗРЕНИЕ

Не мога да изтрия свои грешки,
но мога добрините да повторя:
да облека врабчета с топли дрешки,
да бъда на тревичките опора,
да ви издам пин кода на мечтите,
да бъда гид в държава от усмивки,
да преподавам слънчево излитане,
да изплета от вярата завивки,
да победя с човечност клеветите,
да ви издам, че вечер съм принцеса
на птиците, целувките, звездите,
на ласките от нежно равновесие...
А след това сърдечните вселени
ще ми подскажат бавничко, на срички,
че всъщност със добрите повторения
ще се изтрият грешките самички.





                `}</pre>
      </span>
    </>
  );
}

export default Message;
